export enum TRANSLATE_PATH {
   BANKAMOUNT_TITLE = "project.components.bankamount.title",
   BANKAMOUNT_TOGGLE_BUTTON = "project.components.bankamount.toggle-button.",

   USERDATA_DISPLAY_DIRECTION = "project.components.userdata.display-direction",
   USERDATA_FIRSTNAME = "project.components.userdata.firstname",
   USERDATA_LASTNAME = "project.components.userdata.lastname",
   USERDATA_BANKACCOUNT = "project.components.userdata.bankaccount",
   USERDATA_CUSTOMER = "project.components.userdata.customer",
   
   CONSENT_DECLARATION_BUTTON = "project.pages.consent-declaration.button",

   IDENTIFICATION_TITLE = "project.pages.identification.title",
   IDENTIFICATION_INTRODUCTION = "project.pages.identification.introduction",
   IDENTIFICATION_CODE_LABEL = "project.pages.identification.code.label",
   IDENTIFICATION_CODE_PLACEHOLDER = "project.pages.identification.code.placeholder",
   IDENTIFICATION_CODE_ERROR_PATTERN = "project.pages.identification.code.error.pattern",
   IDENTIFICATION_CODE_ERROR_REQUIRED = "project.pages.identification.code.error.required",
   IDENTIFICATION_CODE_ERROR_NOTEXISTS = "project.pages.identification.code.error.notExists",
   IDENTIFICATION_CODE_ERROR_CONSULTANT = "project.pages.identification.code.error.consultant",
   IDENTIFICATION_CODE_HINT = "project.pages.identification.code.hint",
   IDENTIFICATION_CODE_PENDING = "project.pages.identification.code.pending",
   IDENTIFICATION_BIRTHDAY_LABEL = "project.pages.identification.birthday.label",
   IDENTIFICATION_BIRTHDAY_PLACEHOLDER = "project.pages.identification.birthday.placeholder",
   IDENTIFICATION_BIRTHDAY_ERROR_PATTERN = "project.pages.identification.birthday.error.pattern",
   IDENTIFICATION_BIRTHDAY_ERROR_REQUIRED = "project.pages.identification.birthday.error.required",
   IDENTIFICATION_BIRTHDAY_ERROR_NOTEXISTS = "project.pages.identification.birthday.error.notExists",
   IDENTIFICATION_BIRTHDAY_HINT = "project.pages.identification.birthday.hint",
   IDENTIFICATION_BIRTHDAY_PENDING = "project.pages.identification.birthday.pending",
   IDENTIFICATION_BIRTHDAY_PATTERN = "project.pages.identification.birthday.pattern",
   IDENTIFICATION_STARTWITHOUTBIRTHDAY = "project.pages.identification.startWithoutBirthday",
   IDENTIFICATION_INFO_TEXT = "project.pages.identification.info-text",
   IDENTIFICATION_BUTTON = "project.pages.identification.button",

   CONSENT_DECLARATION_AGREEMENTURL = "project.pages.consent-declaration.agreementUrl",
   CONSENT_DECLARATION_DELAYTIMEREDIRECT = "project.pages.consent-declaration.delayTimeRedirect",
   CONSENT_DECLARATION_TARGET = "project.pages.consent-declaration.target",

   FORWARD_DIALOG_TITLE = "project.dialogs.forward-dialog.title",
   FORWARD_DIALOG_SUBTITLE = "project.dialogs.forward-dialog.subtitle",
   FORWARD_DIALOG_TEXT = "project.dialogs.forward-dialog.text",
   FORWARD_DIALOG_BUTTON = "project.dialogs.forward-dialog.button",
   FORWARD_DIALOG_URL = "project.dialogs.forward-dialog.url",
   FORWARD_DIALOG_SHOWBUTTON = "project.dialogs.forward-dialog.showButton",
   FORWARD_DIALOG_LINK_COLOR = "project.dialogs.forward-dialog.color.link",
   FORWARD_DIALOG_ICON = "project.dialogs.forward-dialog.icon",
   FORWARD_DIALOG_SUBTITLE_COLOR = "project.dialogs.forward-dialog.color.subtitle",
   FORWARD_DIALOG_ICON_COLOR = "project.dialogs.forward-dialog.color.icon",

   SUCCESS_DIALOG_TITLE= "project.dialogs.success-dialog.title",
   SUCCESS_DIALOG_SUBTITLE = "project.dialogs.success-dialog.subtitle",
   SUCCESS_DIALOG_BUTTON = "project.dialogs.success-dialog.button",
   SUCCESS_DIALOG_URL = "project.dialogs.success-dialog.url",
   SUCCESS_DIALOG_SHOWBUTTON = "project.dialogs.success-dialog.showButton",
   SUCCESS_DIALOG_LINK_COLOR = "project.dialogs.success-dialog.color.link",
   SUCCESS_DIALOG_ICON = "project.dialogs.success-dialog.icon",
   SUCCESS_DIALOG_SUBTITLE_COLOR = "project.dialogs.success-dialog.color.subtitle",
   SUCCESS_DIALOG_ICON_COLOR = "project.dialogs.success-dialog.color.icon",

   CONSENT_DECLARATION_REDIRECT_TEXT = "project.pages.consent-declaration.redirect.text",
   CONSENT_DECLARATION_REDIRECT_TARGET = "project.pages.consent-declaration.redirect.target",
   CONSENT_DECLARATION_REDIRECT_LINKTEXT = "project.pages.consent-declaration.redirect.linktext",
   
   IDENTIFICATION_REDIRECT_TEXT = "project.pages.identification.redirect.text",
   IDENTIFICATION_REDIRECT_TARGET = "project.pages.identification.redirect.target",
   IDENTIFICATION_REDIRECT_LINKTEXT = "project.pages.identification.redirect.linktext",
   
   QUESTION_FIELDTYPESTOBESEND = "project.components.question.fieldtypesToBeSend",

   FIELD_ITEMS_PATH_PROJECT = "project.components.field-item",
   FIELD_ITEMS_HREF = "href",
   FIELD_ITEMS_FILENAME = "filename",
}